import SignUpHelpVideoLinks from '@/components/Molecules/SignUpHelpVideoLinks.tsx'
import { CheckCircle } from 'lucide-react'

export function SignupOptions() {
  return (
    <ul className="space-y-3 text-sm leading-loose">
      <li className="item-center flex gap-3">
        <span>
          <CheckCircle className="stroke-primary" />
        </span>
        <span>
          <span className="text-lg font-semibold">
            TxDMV Certificate Number
          </span>
        </span>
      </li>
      <li className="item-center flex gap-3">
        <span>
          <CheckCircle className="stroke-primary" />
        </span>
        <span>
          <span className="text-lg font-semibold">
            Automated Motor Vehicle Authorization
          </span>
        </span>
      </li>
      <li className="item-center flex gap-3">
        <span>
          <CheckCircle className="stroke-primary" />
        </span>
        <span>
          <span className="text-lg font-semibold">
            Insurance Provider Access
          </span>
        </span>
      </li>
      <li className="item-center flex gap-3">
        <span>
          <CheckCircle className="stroke-primary" />
        </span>
        <span>
          <span className="text-lg font-semibold">Licensing Agent Access</span>
        </span>
      </li>
      <li>
        <SignUpHelpVideoLinks />
      </li>
    </ul>
  )
}
